import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/packages/maestro-ui/src/app/page.tsx");
